import { useMemo } from 'react';
import { useAllocationTabQuery } from '../api/useAllocationTabQuery';
import { SERIES_COLORS } from '../../CommonComponents/OPL/charts/charts.constants';
import { useRouteParams } from './useRouteParams';
import { usePeriod } from './usePeriod';
import { defaultPeriod } from '../AccountPerformanceReporting.constants';

interface Params {
  tab: 'left' | 'right';
}

export const useAllocationTab = ({ tab }: Params) => {
  const { accountId, clientId, groupId, tabSlug } = useRouteParams();

  const period = usePeriod();

  const isPositions = tabSlug === 'allocation';

  const queryInfo = useAllocationTabQuery({
    clientId,
    tab,
    period: (isPositions ? defaultPeriod : period).value,
    startDate: (isPositions ? defaultPeriod : period).dates[0],
    endDate: (isPositions ? defaultPeriod : period).dates[1],
    accountId,
    groupId,
  });

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    const { name, marketValue, series } = queryInfo.data;

    const chartData = series.map(({ name: seriesName, value, color, percentage }, index) => ({
      name: seriesName,
      allocation: percentage / 100,
      marketValue: value,
      color: color || SERIES_COLORS[index % SERIES_COLORS.length],
    }));

    return {
      name,
      marketValue,
      chartData,
    };
  }, [queryInfo.data]);

  return { ...queryInfo, data };
};
